import axios from 'axios'

const MAPBOX_API_URL = process.env.MAPBOX_API_URL ?? ''

export const mapboxApi = axios.create({ baseURL: MAPBOX_API_URL })
